import * as PIXI from 'pixi.js';

require('pixi-spine');

global.PIXI = PIXI;
